// extracted by mini-css-extract-plugin
module.exports = {"container":"NewTheatreBtn_container__2i1jo"};